export const createEventsRepository = (appFetch) => {
    return {
        list(params = {}) {
            return appFetch.get('/api/v1/bank-events', {params});
        },
        latest(params = {}) {
            return appFetch.get('/api/v1/bank-events/latest', {params});
        },
        details(slug, params = {}) {
            return appFetch.get(`/api/v1/bank-events/${slug}`, {params});
        },
    };
};
